// Dados de contato do escritório: usados na home, nos guias, no rodapé e nas marcações para o Google.
// Mantenha iguais ao Perfil da Empresa no Google.

export const SITE_URL = 'https://navarroevieiraadvogados.com.br';

export const OFFICE = {
  name: 'Navarro & Vieira Advogados',
  street: 'Rua Bélgica, nº 437, Centro',
  city: 'Cambé/PR',
  cep: '86181-090',
  phone: '(43) 3035-5730',
  hours: 'Segunda a sexta, das 9h às 11h30 e das 13h30 às 17h30.',
  plantao: 'Prisões em flagrante e urgências criminais, em qualquer dia e horário.',
  emailDomain: '@navarroevieiraadvogados.com.br',
  instagram: '@navarrovieiraadvogados',
  instagramUrl: 'https://www.instagram.com/navarrovieiraadvogados/'
};

export const LAWYERS = [
  {
    name: 'Mateus Bortotto Vieira',
    oab: 'OAB/PR 101.759',
    email: 'mateus@navarroevieiraadvogados.com.br',
    phone: '(43) 98817-2533',
    photo: '/Mateus.png',
    photoWebp: '/Mateus.webp'
  },
  {
    name: 'Marcos Antônio dos Santos Navarro',
    oab: 'OAB/PR 101.424',
    email: 'marcos@navarroevieiraadvogados.com.br',
    phone: '(43) 99936-0457',
    photo: '/Marcos.png',
    photoWebp: '/Marcos.webp'
  }
];

export const getPhoneDigits = (phone) => phone.replace(/\D/g, '');

export const getTelLink = (phone) => `tel:+55${getPhoneDigits(phone)}`;

export const getWhatsAppLink = (phone) => {
  const digits = getPhoneDigits(phone);
  const whatsappNumber = digits.startsWith('55') ? digits : `55${digits}`;
  const message = encodeURIComponent('Olá! Vim pelo site e gostaria de orientação jurídica.');
  return `https://wa.me/${whatsappNumber}?text=${message}`;
};
